
export type RoundMethod = 'ceil';


export class DateTimeUtils {

  timestamp(): string {
    return new Date().toISOString();
  }

  timestampByUnixtime(timestamp: number): string {
    let result = '';
    if (timestamp && timestamp !== 0) {
      result = new Date(timestamp * 1000).toISOString();
    }
    return result;
  }

  getBrowserTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}

export const dateTimeUtils = new DateTimeUtils();
